import React from "react";

// Quiet internal link row. Plain <a href> on purpose: several of these targets
// are flat HTML pages served outside the React router, and plain anchors are
// what ends up in the prerendered HTML that crawlers read first.
export const EXPLORE_LINKS = [
  { href: "/bay-views", label: "Bay Views, Hayat Island — ready now" },
  { href: "/hayat-island", label: "Hayat Island" },
  { href: "/areas/al-marjan-island", label: "Al Marjan Island" },
  { href: "/why-invest-in-ras-al-khaimah", label: "Why invest in Ras Al Khaimah" },
  { href: "/dubai-market-update-2026", label: "Dubai market update 2026" },
  { href: "/bayn-ora-vs-palm-jebel-ali", label: "Bayn vs Palm Jebel Ali" },
  { href: "/dubai-real-estate/buyer-guides/how-to-buy-property-in-dubai-and-rak", label: "How to buy in Dubai & RAK" },
  { href: "/dubai-real-estate/rak-vs-dubai", label: "RAK vs Dubai guides" },
  { href: "/uae-2-pillar-guide", label: "UAE two-pillar guide" },
  { href: "/rak-waterfront-pulse", label: "RAK waterfront pulse" },
  { href: "/dubai-real-estate/rak-vs-dubai/wynn-al-marjan-island-tracker", label: "Wynn Al Marjan tracker" },
  { href: "/rak-vs-dubai-investment", label: "RAK vs Dubai for investors" },
  { href: "/rak-highest-yield-areas", label: "Highest-yield areas in RAK" },
  { href: "/rak-property-investment", label: "RAK property investment" },
  { href: "/dubai-rental-yields-roi", label: "Dubai rental yields & ROI" },
  { href: "/uae-golden-visa-property-investment", label: "Golden Visa through property" },
  { href: "/marina-shores", label: "Marina Shores, Dubai Marina" },
  { href: "/ritz-carlton-residences", label: "Ritz-Carlton Residences" },
  { href: "/bay-residences", label: "Bay Residences" },
  { href: "/episodes", label: "Video episodes" },
];

/**
 * @param {object} props
 * @param {"light"|"dark"} [props.tone] - "light" for cream sections, "dark" for the ink footer.
 * @param {string} [props.className]
 * @param {string} [props.heading]
 */
export default function ExploreLinks({ tone = "light", className = "", heading = "Explore" }) {
  const dark = tone === "dark";
  return (
    <nav
      aria-label="Explore"
      className={className}
      data-testid="explore-links"
    >
      <div className="font-medium text-[0.68rem] tracking-[0.22em] uppercase mb-4 text-gold">
        {heading}
      </div>
      <ul className="flex flex-wrap gap-x-7 gap-y-2 text-sm font-light">
        {EXPLORE_LINKS.map((l) => (
          <li key={l.href}>
            <a
              href={l.href}
              className={`transition-colors ${
                dark ? "text-bone/75 hover:text-gold" : "text-ink/75 hover:text-gold"
              }`}
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
